import { DocumentValueCodes, DocumentValueCodesTranslations } from '@/enums/documentValueCodes.enum';

/**
 * Tłumaczenie kodu wartości dokumentu
 *
 * @export
 * @param {string} name
 * @returns {string}
 */
export function documentValueTranslation(code: DocumentValueCodes): string {
  return (DocumentValueCodesTranslations as any)[code] || code;
}
